import { ChangeEvent } from "react";
import { ParcelamentoContainer, ParcelamentoLabel } from "../style";

interface ParcelamentoState {
  parcela: string;
  parcelas: (string | number)[];
  intervalo: string;
  intervalos: (string | number)[];
  prazo: string;
  prazoMedio: (string | number)[];
  useEspecialConditions: boolean;
  setParcela: (value: string) => void;
  setIntervalo: (value: string) => void;
  setPrazo: (value: string) => void;
}

interface DefaultParcelamentoProps {
  useEspecialConditions: boolean;
  parcelamento: ParcelamentoState;
  disabled?: boolean;
}

const DefaultParcelamento = ({
  useEspecialConditions,
  parcelamento,
  disabled = false,
}: DefaultParcelamentoProps) => {
  const changeParcelas = (value: string) => {
    parcelamento.setParcela(value);
  };

  const changeIntervalo = (value: string) => {
    parcelamento.setIntervalo(value);
  };

  const changePrazoMedio = (value: string) => {
    parcelamento.setPrazo(value);
  };

  return (
    <ParcelamentoContainer>
      <ParcelamentoLabel>
        <span>Parcelas:</span>
        <select
          name="parcelas"
          value={parcelamento.parcela}
          onChange={(event: ChangeEvent<HTMLSelectElement>) => {
            changeParcelas(event.target.value);
          }}
          disabled={
            disabled ||
            useEspecialConditions ||
            parcelamento.parcelas.length < 1
          }
        >
          <option value="">Selecione</option>
          {parcelamento.parcelas &&
            parcelamento.parcelas.map(value => (
              <option key={value} value={value}>
                {value}
              </option>
            ))}
        </select>
      </ParcelamentoLabel>

      <ParcelamentoLabel>
        <span>Intervalo:</span>
        <select
          name="intervalo"
          value={parcelamento.intervalo}
          onChange={(event: ChangeEvent<HTMLSelectElement>) => {
            changeIntervalo(event.target.value);
          }}
          disabled={
            disabled ||
            useEspecialConditions ||
            parcelamento.intervalos.length < 1
          }
        >
          <option value="">Selecione</option>
          {parcelamento.intervalos &&
            parcelamento.intervalos.map(value => (
              <option key={value} value={value}>
                {value} (
                {Number(value) > 0 ? "Parcelamento" : "Divisão de boletos"})
              </option>
            ))}
        </select>
      </ParcelamentoLabel>
      <ParcelamentoLabel>
        <span>Prazo médio:</span>
        <select
          name="prazoMedio"
          value={parcelamento.prazo}
          onChange={(event: ChangeEvent<HTMLSelectElement>) => {
            changePrazoMedio(event.target.value);
          }}
          disabled={
            disabled ||
            useEspecialConditions ||
            parcelamento.prazoMedio.length < 1
          }
        >
          <option value="">Selecione</option>
          {parcelamento.prazoMedio &&
            parcelamento.prazoMedio.map(value => (
              <option key={value} value={value}>
                {value} dias
              </option>
            ))}
        </select>
      </ParcelamentoLabel>
    </ParcelamentoContainer>
  );
};

export default DefaultParcelamento;
